export default __webpack_public_path__ + "static/media/acceleradar.dd2cb48e.png";